import { ApolloLink } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import getClientEnvironment from '../getClientEnvironment';

const config = getClientEnvironment();
let link: ApolloLink | null = null;

const create = (): ApolloLink => {
    const httpLink = new BatchHttpLink({
        credentials: 'same-origin',
        uri: config.GRAPHQL_ENDPOINT
    });

    return httpLink;
};

export default () => {
    if (!link) {
        link = create();
    }
    return link;
};



// WEBPACK FOOTER //
// ./src/client/apollo/configureRemoteApolloLink.tsx